import { deleteDoc, doc, getFirestore } from "firebase/firestore";
import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import type { RutasContextValue } from "../../../context/types";
import {
  useAuthState,
  useRutasActions,
} from "../../../context/AppContext";
import type {
  ModalDeleteRutaProps,
  UseModalDeleteRutaReturn,
} from "./types";

const removerRutaDelEstadoLocal = (
  rutaUid: string,
  setRutasData: RutasContextValue["setRutasData"]
): void => {
  setRutasData((prevRutas) =>
    prevRutas ? prevRutas.filter((ruta) => ruta.uid !== rutaUid) : prevRutas
  );
};

export const useModalDeleteRuta = ({
  selectedRuta,
  setShowModalDelete,
}: ModalDeleteRutaProps): UseModalDeleteRutaReturn | null => {
  const { setRutasData } = useRutasActions();
  const { userData } = useAuthState();
  const [isDeleting, setIsDeleting] = useState(false);
  const adminUid = userData?.uid ?? null;
  const selectedRutaUid = selectedRuta?.uid ?? null;

  const handleClose = useCallback(() => {
    setShowModalDelete(false);
  }, [setShowModalDelete]);

  const deleteRuta = useCallback(async () => {
    if (isDeleting || !selectedRutaUid || !adminUid) {
      return;
    }

    setIsDeleting(true);

    try {
      const db = getFirestore();
      const rutaRef = doc(db, "admin_users", adminUid, "rutas", selectedRutaUid);

      await deleteDoc(rutaRef);

      removerRutaDelEstadoLocal(selectedRutaUid, setRutasData);

      handleClose();
      toast.success("Ruta Eliminada con exito");
    } catch (error) {
      console.error("Error al eliminar la ruta:", error);
      toast.error("No se pudo eliminar la ruta");
    } finally {
      setIsDeleting(false);
    }
  }, [adminUid, handleClose, isDeleting, selectedRutaUid, setRutasData]);

  if (!selectedRutaUid) {
    return null;
  }

  return {
    deleteRuta,
    handleClose,
    isDeleting,
    selectedRuta,
  };
};
